var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticStyle:{"display":"block","width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }